"use client";

import { useSearch } from "@packages/framework";
import { useContext, useEffect } from "react";

import { redirectToAuth } from "../../lib";
import { sessionContext } from "../sessionContext";

export type UseSessionProps = {
  onAuthenticated?: ({ isNewUser }: { isNewUser: boolean }) => void;
  onUnauthenticated?: Function;
  required?: boolean;
};

export const useSession = ({
  onAuthenticated,
  onUnauthenticated,
  required = false,
}: UseSessionProps = {}) => {
  const search = useSearch();

  const isAuthenticated = search.get("isAuthenticated");
  const isNewUser = search.get("isNewUser");

  const { resetSessionURLSearchParameters, status, ...rest } =
    useContext(sessionContext);

  useEffect(() => {
    if (isAuthenticated === "true" && status === "authenticated")
      if (onAuthenticated) onAuthenticated({ isNewUser: isNewUser === "true" });
  }, [isAuthenticated, isNewUser, status]);

  useEffect(() => {
    if (status === "unauthenticated" && required) {
      if (onUnauthenticated) onUnauthenticated();
      else redirectToAuth();
    }
  }, [required, status]);

  return {
    resetSessionURLSearchParameters,
    status,
    ...rest,
  };
};
